export const setLoading = (value) => {
  return {
    type: "SET_LOADING",
    payload: { data: value },
  };
};
export const setMemberLoading = (value) => {
  return {
    type: "SET_MEMBER_LOADING",
    payload: { data: value },
  };
};
export const setCommonLoading = (value) => {
  return {
    type: "SET_COMMON_LOADING",
    payload: { data: value },
  };
};

